<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  watch: {
    $route() {
      if (window.core) {
        if (this.$route.path == '/main') {
          window.core.setWebViewHeight(60)
        } else {
          window.core.getWindowHeight((height) => {
            window.core.setWebViewHeight(height)
          })
        }
      }
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.$vConsole.setSwitchPosition(100, 100)
    // }, 3000)
  }
}
</script>
<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #0a084d;
  // background: url("./assets/bk.png") no-repeat center;
  // background-size: 100% 100%;
  background: radial-gradient(circle, #2e2c8a 0%, #04070F 100%);
  // background: radial-gradient(circle, #0065D9 0%, #04070F 100%);
  // background: #2e2c8a;
}
* {
  box-sizing: border-box;
}
</style>
